import { SellerNotifications as SellerNotificationsComponent } from 'components/sellers/SellerNotifications/SellerNotifications'
import { useParams } from 'react-router-dom'

export const SellerNotifications: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <SellerNotificationsComponent type='seller' sellerId={id as string} />
}
